import { useHaloUser } from '@/features/halocrm-user/hooks'

type Props = {
  /** Konsultant prowadzący umowę (assignee_user_id, ustawiany m.in. przez auto-przydział). */
  assigneeUserId: number | null
}

/** Read-only: kto prowadzi umowę. "Nieprzypisana" gdy w kolejce (brak konsultanta). */
export function AssigneeWidget({ assigneeUserId }: Props) {
  const resolved = useHaloUser(assigneeUserId)

  const displayName = (() => {
    if (assigneeUserId == null) return 'Nieprzypisana'
    if (resolved.isLoading) return 'Ładowanie...'
    if (resolved.data) return resolved.data.fullName
    return `#${assigneeUserId}`
  })()

  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-xs uppercase text-slate-500">Opiekun:</span>
      <span className={assigneeUserId == null ? 'text-amber-600' : undefined}>{displayName}</span>
    </div>
  )
}
